import { createContext } from 'react';

const AppContext = createContext(undefined);

export default AppContext;
